if (!customElements.get('reliv-offer-selector')) {
  customElements.define(
    'reliv-offer-selector',
    class RelivOfferSelector extends HTMLElement {
      constructor() {
        super();
        this.variantInput = this.querySelector('input[name="id"]');
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange(evt) {
        if (evt.target.name !== this.dataset.radioName) return;
        this.variantInput.value = evt.target.value;
        this.querySelectorAll('.reliv-offer-card').forEach((card) => {
          card.classList.toggle('is-selected', card.contains(evt.target));
        });

        const submitLabel = this.querySelector('[data-reliv-submit-label]');
        if (submitLabel && evt.target.dataset.price && evt.target.dataset.days) {
          submitLabel.textContent = `Start Your ${evt.target.dataset.days}-Day Ritual — ${evt.target.dataset.price}`;
        }

        window.dispatchEvent(
          new CustomEvent('reliv:offer-selected', {
            detail: { price: evt.target.dataset.price, radioName: this.dataset.radioName },
          })
        );
      }
    }
  );
}
